import * as Sentry from '@sentry/react';

export type ErrorSurface =
  | 'global'
  | 'react-render'
  | 'router'
  | 'react-query'
  | 'logger'
  | 'handled'
  | 'unknown'
  | (string & {});

export interface ReportErrorOptions {
  surface: ErrorSurface;
  feature?: string;
  operation?: string;
  tags?: Record<string, string>;
  extra?: Record<string, unknown>;
}

function toError(error: unknown): Error {
  if (error instanceof Error) {
    return error;
  }

  if (typeof error === 'string') {
    return new Error(error);
  }

  return new Error('Unknown error');
}

/**
 * Capture an exception with standardized Sentry tags and context.
 */
export function reportError(error: unknown, options: ReportErrorOptions): void {
  const normalized = toError(error);

  Sentry.withScope((scope) => {
    scope.setTag('surface', options.surface);

    if (options.feature !== undefined && options.feature !== '') {
      scope.setTag('feature', options.feature);
    }

    if (options.operation !== undefined && options.operation !== '') {
      scope.setTag('operation', options.operation);
    }

    if (options.tags !== undefined) {
      Object.entries(options.tags).forEach(([key, value]) => {
        scope.setTag(key, value);
      });
    }

    if (options.extra !== undefined) {
      scope.setExtras(options.extra);
    }

    Sentry.captureException(normalized);
  });
}
